import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ValidateServiceService as AuthGuard } from './shareModule/services/validate-service.service';

import { FeedbacksComponent } from './admin/auth/feedbacks/feedbacks.component';
import { DashboardAdminComponent } from './admin/layout/dashboard-admin/dashboard-admin.component';
import { NewHomepageComponent } from './admin/new-homepage/new-homepage.component';
import { BusinessJoinFormComponent } from './business/bussiness-join-form/business-join-form.component';
import { BusinessModule } from './business/business.module';
import { ClientShareReviewLinkComponent } from './admin/client-share-review-link/client-share-review-link.component';
import { UserShareReviewLinkComponent } from './admin/user-share-review-link/user-share-review-link.component';

const routes: Routes = [
  { path: 'admin/login', component: NewHomepageComponent },
  {
    path: 'admin',
    component: DashboardAdminComponent,
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
    canActivate: [AuthGuard],
    data: {
      allowedRoles: ['admin'],
    },
  },
  {
    path: 'biz/join',
    component: BusinessJoinFormComponent
    // loadChildren: () =>
    //   import('./business/business.module').then((m) => m.BusinessModule),
  },
  {
    path: 'user-review-share',
    component: UserShareReviewLinkComponent,
    // canActivate: [AuthGuard],
    // data: {
    //   allowedRoles: ["admin"]
    // }
  },
  {
    path: 'client-review-share',
    component: ClientShareReviewLinkComponent,
    // canActivate: [AuthGuard],
    // data: {
    //   allowedRoles: ["admin"]
    // }
  },
  { path: 'feedbacks/:id', component: FeedbacksComponent },
  // ***** Write New Routes and import either in Admin/customer module router file *****
  // {
  //   path: '',
  //   loadChildren: () =>
  //     import('./customers/customers.module').then((m) => m.CustomersModule),
  // },
  //Admin
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    useHash: false,
    scrollPositionRestoration: 'enabled',
    // paramsInheritanceStrategy: 'always',
  }), BusinessModule /** Has only 1 page and that page is lagging */],
  exports: [RouterModule]
})
export class AppRoutingModule { }
